/* the othr. — Pastel theme scripts
   Vanilla JS, progressive enhancement over native Shopify forms. */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};
  var strings = theme.strings || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function root(path) {
    var base = routes.root || '/';
    if (base.slice(-1) !== '/') base += '/';
    return base + path.replace(/^\//, '');
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(message, isError) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.toggle('toast--error', !!isError);
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 300);
    }, 3200);
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (header) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    var toggle = $('[data-menu-toggle]');
    var list = $('[data-nav-list]');
    if (!toggle || !list) return;
    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      list.classList.toggle('is-open', open);
    }
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    list.addEventListener('click', function (e) {
      if (e.target.closest('[data-nav-link]')) setOpen(false);
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-nav-list]') && !e.target.closest('[data-menu-toggle]')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        toggle.focus();
      }
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var items = $$('[data-reveal]');
    if (!items.length) return;
    var html = document.documentElement;
    if (reduceMotion || !html.classList.contains('motion-ok') || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
    // Safety net: never leave content hidden.
    setTimeout(function () { items.forEach(function (el) { el.classList.add('is-revealed'); }); }, 4000);
  }

  /* ---------- Quantity steppers (product forms) ---------- */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var wrap = (minus || plus).closest('[data-qty]');
      var input = wrap && $('[data-qty-input]', wrap);
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      var max = parseInt(input.max, 10) || 99;
      val = minus ? Math.max(1, val - 1) : Math.min(max, val + 1);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qty-input]')) return;
      var v = parseInt(e.target.value, 10);
      if (!v || v < 1) e.target.value = 1;
    });
  }

  /* ---------- Variant selection ---------- */
  function readVariants(formEl) {
    if (formEl._variants) return formEl._variants;
    var script = $('[data-variants]', formEl);
    try { formEl._variants = script ? JSON.parse(script.textContent) : []; } catch (err) { formEl._variants = []; }
    return formEl._variants;
  }

  function setButtonState(btn, available, label) {
    if (!btn) return;
    btn.disabled = !available;
    var lab = $('[data-add-label]', btn);
    if (lab) lab.textContent = label;
  }

  function onOptionChange(input) {
    var pf = input.closest('[data-product-form]');
    if (!pf) return;
    var variants = readVariants(pf);
    var selected = $$('fieldset[data-option-index]', pf).map(function (fs) {
      var checked = $('input:checked', fs);
      return checked ? checked.value : null;
    });
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      var match = variants[i].options.every(function (opt, idx) { return opt === selected[idx]; });
      if (match) { variant = variants[i]; break; }
    }
    var scope = pf.closest('[data-product-scope]') || pf;
    var addBtn = $('[data-add-button]', pf);
    var stickyBtn = $('[data-sticky-button]', scope);

    if (!variant) {
      setButtonState(addBtn, false, strings.unavailable);
      setButtonState(stickyBtn, false, strings.unavailable);
      return;
    }

    var idInput = $('[data-variant-id]', pf);
    if (idInput) idInput.value = variant.id;

    $$('[data-price-current]', scope).forEach(function (el) { el.textContent = variant.price; });
    $$('[data-price-compare]', scope).forEach(function (el) {
      if (variant.compare) { el.textContent = variant.compare; el.hidden = false; }
      else { el.textContent = ''; el.hidden = true; }
    });
    $$('[data-price]', scope).forEach(function (el) { el.classList.toggle('price--sale', !!variant.compare); });

    var label = variant.available ? strings.addToCart : strings.soldOut;
    setButtonState(addBtn, variant.available, label);
    setButtonState(stickyBtn, variant.available, label);

    var sp = $('[data-sticky-price]', scope);
    if (sp) sp.textContent = variant.price;
    var sv = $('[data-sticky-variant]', scope);
    if (sv) sv.textContent = variant.options.join(' / ') + ' · ';

    hideFormError(pf);

    if (pf.dataset.context === 'main') {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (err) { /* ignore */ }
      if (variant.media) goToMedia(scope, String(variant.media));
    }
  }

  function initVariants() {
    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) onOptionChange(e.target);
    });
  }

  /* ---------- Form errors ---------- */
  function showFormError(formWrap, message) {
    var box = formWrap && $('[data-form-error]', formWrap);
    if (!box) { toast(message, true); return; }
    var text = $('[data-form-error-text]', box);
    if (text) text.textContent = message; else box.textContent = message;
    box.hidden = false;
  }
  function hideFormError(formWrap) {
    var box = formWrap && $('[data-form-error]', formWrap);
    if (box) box.hidden = true;
  }

  /* ---------- Cart ---------- */
  var drawer = null;
  var lastFocus = null;

  function cartSections() {
    var ids = [];
    if ($('[data-cart-drawer]')) ids.push('cart-drawer');
    var page = $('[data-cart-page]');
    if (page) {
      var wrap = page.closest('.shopify-section');
      if (wrap && wrap.id) ids.push(wrap.id.replace('shopify-section-', ''));
    }
    return ids;
  }

  function parseSection(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  }

  function renderSections(sections) {
    if (!sections) return null;
    var count = null;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      if (id === 'cart-drawer') {
        var fresh = parseSection(html, '[data-cart-drawer]');
        var current = $('[data-cart-drawer]');
        if (fresh && current) {
          var freshPanel = $('[data-cart-panel]', fresh);
          var panel = $('[data-cart-panel]', current);
          if (freshPanel && panel) panel.innerHTML = freshPanel.innerHTML;
          current.dataset.itemCount = fresh.dataset.itemCount;
          count = parseInt(fresh.dataset.itemCount, 10);
        }
      } else {
        var freshBody = parseSection(html, '[data-cart-page-body]');
        var body = $('[data-cart-page-body]');
        if (freshBody && body) body.innerHTML = freshBody.innerHTML;
      }
    });
    return count;
  }

  function updateCount(count) {
    if (count === null || isNaN(count)) return;
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      if (!reduceMotion) el.classList.add('is-bumped');
    });
    $$('[data-cart-open]').forEach(function (link) {
      var tpl = link.getAttribute('data-cart-label-template');
      if (tpl) link.setAttribute('aria-label', tpl.replace('__COUNT__', count));
    });
  }

  function refreshCart() {
    var ids = cartSections();
    if (!ids.length) return refreshCount();
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var count = renderSections(sections);
        if (count === null) refreshCount(); else updateCount(count);
      })
      .catch(function () { refreshCount(); });
  }

  function refreshCount() {
    return fetch(root('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); return cart; })
      .catch(function () {});
  }

  function focusables(el) {
    return $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return n.offsetParent !== null; });
  }

  function openDrawer() {
    drawer = $('[data-cart-drawer]');
    if (!drawer) { window.location.href = routes.cart; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var panel = $('[data-cart-panel]', drawer);
    setTimeout(function () { if (panel) panel.focus(); }, 50);
  }

  function closeDrawer() {
    drawer = $('[data-cart-drawer]');
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function initDrawer() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener && $('[data-cart-drawer]') && theme.cartType !== 'page') {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (e.target.closest('[data-cart-close]')) {
        e.preventDefault();
        closeDrawer();
        return;
      }
      var closeLink = e.target.closest('[data-cart-close-link]');
      if (closeLink && closeLink.closest('[data-cart-drawer]')) {
        var href = closeLink.getAttribute('href') || '';
        if (href.indexOf('#') === 0 || href === window.location.pathname) closeDrawer();
      }
    });

    document.addEventListener('keydown', function (e) {
      var d = $('[data-cart-drawer]');
      if (!d || !d.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key === 'Tab') {
        var panel = $('[data-cart-panel]', d);
        var f = focusables(panel);
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  function setLoading(btns, loading) {
    btns.forEach(function (b) {
      if (!b) return;
      b.classList.toggle('is-loading', loading);
      b.setAttribute('aria-busy', loading ? 'true' : 'false');
      if (loading) { b.dataset.wasDisabled = b.disabled ? '1' : ''; b.disabled = true; }
      else if (!b.dataset.wasDisabled) { b.disabled = false; }
    });
  }

  function flashAdded(btns) {
    btns.forEach(function (b) {
      if (!b) return;
      var lab = $('[data-add-label]', b);
      var prev = lab ? lab.textContent : null;
      b.classList.add('is-added');
      if (lab) lab.textContent = strings.added;
      setTimeout(function () {
        b.classList.remove('is-added');
        if (lab && prev !== null && lab.textContent === strings.added) lab.textContent = prev;
      }, 1600);
    });
  }

  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      if (theme.cartType === 'page' || !window.fetch || !window.FormData) return;
      e.preventDefault();

      var wrap = form.closest('[data-product-form]') || form;
      var btns = [e.submitter, $('[data-add-button]', form)];
      if (form.id) btns = btns.concat($$('[form="' + form.id + '"][data-add-button]'));
      btns = btns.filter(function (b, i, arr) { return b && arr.indexOf(b) === i; });

      hideFormError(wrap);
      setLoading(btns, true);

      var fd = new FormData(form);
      var sections = cartSections();
      if (sections.length) {
        fd.append('sections', sections.join(','));
        fd.append('sections_url', window.location.pathname);
      }

      fetch(root('cart/add.js'), {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          setLoading(btns, false);
          if (!res.ok || res.data.status) {
            var msg = (res.data && (res.data.description || res.data.message)) || strings.error;
            showFormError(wrap, msg);
            // Shopify may still add the available quantity – keep the cart in sync.
            refreshCart();
            return;
          }
          var count = renderSections(res.data.sections);
          if (count === null) refreshCount(); else updateCount(count);
          flashAdded(btns);
          if ($('[data-cart-drawer]')) openDrawer();
          else toast(strings.added);
        })
        .catch(function () {
          setLoading(btns, false);
          showFormError(wrap, strings.error);
        });
    });
  }

  function changeLine(lineEl, quantity) {
    var line = parseInt(lineEl.dataset.line, 10);
    if (!line) return;
    var d = $('[data-cart-drawer]');
    if (d && lineEl.closest('[data-cart-drawer]')) d.classList.add('is-busy');
    lineEl.classList.add('is-updating');
    var errorBox = $('[data-line-error]', lineEl);
    if (errorBox) errorBox.hidden = true;

    fetch(root('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: cartSections(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (d) d.classList.remove('is-busy');
        if (!res.ok || res.data.status) {
          lineEl.classList.remove('is-updating');
          var msg = (res.data && (res.data.description || res.data.message)) || strings.error;
          if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; } else toast(msg, true);
          return;
        }
        var key = lineEl.dataset.key;
        renderSections(res.data.sections);
        updateCount(res.data.item_count);
        // Shopify caps quantities at available stock – tell the shopper if that happened.
        if (quantity > 0 && res.data.items) {
          var item = res.data.items.filter(function (it) { return it.key === key; })[0];
          if (item && item.quantity < quantity) {
            var fresh = $('[data-key="' + key + '"] [data-line-error]');
            if (fresh) { fresh.textContent = strings.quantityError; fresh.hidden = false; }
            else toast(strings.quantityError, true);
          }
        }
      })
      .catch(function () {
        if (d) d.classList.remove('is-busy');
        lineEl.classList.remove('is-updating');
        toast(strings.error, true);
      });
  }

  function initCartLines() {
    document.addEventListener('click', function (e) {
      var change = e.target.closest('[data-cart-change]');
      var remove = e.target.closest('[data-cart-remove]');
      if (!change && !remove) return;
      var lineEl = (change || remove).closest('[data-line]');
      if (!lineEl) return;
      e.preventDefault();
      var q = remove ? 0 : Math.max(0, parseInt(change.getAttribute('data-cart-change'), 10) || 0);
      changeLine(lineEl, q);
    });
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-input]')) return;
      var lineEl = e.target.closest('[data-line]');
      if (!lineEl) return;
      var q = Math.max(0, parseInt(e.target.value, 10) || 0);
      changeLine(lineEl, q);
    });
    // Enter in a cart quantity field should update, not submit to checkout.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-cart-input]')) {
        e.preventDefault();
        e.target.blur();
      }
    });
  }

  /* ---------- Gallery ---------- */
  function goToMedia(scope, mediaId) {
    var gallery = $('[data-gallery]', scope);
    if (!gallery) return;
    var track = $('[data-gallery-track]', gallery);
    var slide = $('[data-media-id="' + mediaId + '"]', gallery);
    if (!track || !slide) return;
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    setActiveThumb(gallery, mediaId);
  }

  function setActiveThumb(gallery, mediaId) {
    $$('[data-gallery-thumb]', gallery).forEach(function (t) {
      var on = t.getAttribute('data-gallery-thumb') === String(mediaId);
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
  }

  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      var track = $('[data-gallery-track]', gallery);
      if (!track) return;
      var slides = $$('[data-media-id]', track);
      var scope = gallery.closest('[data-product-scope]') || gallery;

      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-gallery-thumb]');
        if (thumb) { goToMedia(scope, thumb.getAttribute('data-gallery-thumb')); return; }
        var prev = e.target.closest('[data-gallery-prev]');
        var next = e.target.closest('[data-gallery-next]');
        if (prev || next) {
          var w = track.clientWidth;
          var idx = Math.round(track.scrollLeft / w) + (next ? 1 : -1);
          idx = (idx + slides.length) % slides.length;
          goToMedia(scope, slides[idx].getAttribute('data-media-id'));
        }
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var idx = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          var s = slides[Math.min(slides.length - 1, Math.max(0, idx))];
          if (s) setActiveThumb(gallery, s.getAttribute('data-media-id'));
          ticking = false;
        });
      }, { passive: true });

      track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var idx = Math.round(track.scrollLeft / track.clientWidth) + (e.key === 'ArrowRight' ? 1 : -1);
        idx = Math.min(slides.length - 1, Math.max(0, idx));
        goToMedia(scope, slides[idx].getAttribute('data-media-id'));
      });

      // Start on the selected variant's image.
      var form = $('[data-product-form]', scope);
      if (form) {
        var id = $('[data-variant-id]', form);
        var variants = readVariants(form);
        var v = id && variants.filter(function (x) { return String(x.id) === id.value; })[0];
        if (v && v.media && slides.length > 1) {
          var slide = $('[data-media-id="' + v.media + '"]', track);
          if (slide && slide !== slides[0]) {
            track.scrollLeft = slide.offsetLeft - track.offsetLeft;
            setActiveThumb(gallery, v.media);
          }
        }
      }
    });
  }

  /* ---------- Sticky add to cart (mobile) ---------- */
  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    var main = $('[data-product-main]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var target = $('[data-product-form] [data-add-button]', main);
    if (!target) return;
    var mq = window.matchMedia('(max-width: 989px)');
    var footer = $('.site-footer');
    var mainVisible = true;
    var footerVisible = false;

    function update() {
      var show = mq.matches && !mainVisible && !footerVisible && target.getBoundingClientRect().top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var btn = $('[data-sticky-button]', bar);
      if (btn) btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('has-sticky-atc', show);
      document.body.style.setProperty('--sticky-h', show ? bar.offsetHeight + 'px' : '0px');
    }

    new IntersectionObserver(function (entries) {
      mainVisible = entries[0].isIntersecting;
      update();
    }).observe(target);

    if (footer) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        update();
      }).observe(footer);
    }
    if (mq.addEventListener) mq.addEventListener('change', update);
  }

  /* ---------- Init ---------- */
  function init() {
    initHeader();
    initReveal();
    initQuantity();
    initVariants();
    initDrawer();
    initAddToCart();
    initCartLines();
    initGallery();
    initStickyAtc();

    // Restore cart count after back/forward cache navigation.
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
